export interface ITemperature {
    [key: string]: number[]
}

export const temperature: ITemperature = {
    'WTG000': [43.6, 45.0, 29.9],
    'WTG001': [43.6, 45.0, 29.9],
    'WTG002': [43.6, 45.0, 29.9],
    'WTG003': [43.6, 45.0, 29.9],
    'WTG004': [43.6, 45.0, 29.9],
    'WTG005': [43.6, 45.0, 29.9],
    'WTG006': [43.6, 45.0, 29.9],
    'WTG007': [43.6, 45.0, 29.9],
    'WTG008': [43.6, 45.0, 29.9],
    'WTG009': [43.6, 45.0, 29.9],
    'WTG010': [43.6, 45.0, 29.9],
    'WTG011': [43.6, 45.0, 29.9],
    'WTG012': [43.6, 45.0, 29.9],
    'WTG013': [43.6, 45.0, 29.9],
    'WTG014': [43.6, 45.0, 29.9],
    'WTG015': [43.6, 45.0, 29.9],
    'WTG016': [43.6, 45.0, 29.9],
    'WTG017': [43.6, 45.0, 29.9],
    'WTG018': [43.6, 45.0, 29.9],
    'WTG019': [43.6, 45.0, 29.9],
    'WTG020': [43.6, 45.0, 29.9],
    'WTG021': [43.6, 45.0, 29.9],
    'WTG022': [43.6, 45.0, 29.9],
    'WTG023': [43.6, 45.0, 29.9],
    'WTG024': [43.6, 45.0, 29.9],
    'WTG025': [43.6, 45.0, 29.9],
    'WTG026': [43.6, 45.0, 29.9],
    'WTG027': [43.6, 45.0, 29.9],
    'WTG028': [43.6, 45.0, 29.9],
    'WTG029': [43.6, 45.0, 29.9],
    'WTG030': [43.6, 45.0, 29.9],
    'WTG031': [43.6, 45.0, 29.9],
    'WTG032': [43.6, 45.0, 29.9],
    'WTG033': [43.6, 45.0, 29.9],
    'WTG034': [43.6, 45.0, 29.9],
    'WTG035': [43.6, 45.0, 29.9],
    'WTG036': [43.6, 45.0, 29.9],
    'WTG037': [43.6, 45.0, 29.9],
    'WTG038': [43.6, 45.0, 29.9],
    'WTG039': [43.6, 45.0, 29.9],
    'WTG040': [43.6, 45.0, 29.9],
    'WTG041': [43.6, 45.0, 29.9],
    'WTG042': [43.6, 45.0, 29.9],
    'WTG043': [43.6, 45.0, 29.9],
    'WTG044': [43.6, 45.0, 29.9],
    'WTG045': [43.6, 45.0, 29.9],
    'WTG046': [43.6, 45.0, 29.9],
    'WTG047': [43.6, 45.0, 29.9],
    'WTG048': [43.6, 45.0, 29.9],
    'WTG049': [43.6, 45.0, 29.9],
    'WTG050': [43.6, 45.0, 29.9],
    'WTG051': [43.6, 45.0, 29.9],
    'WTG052': [43.6, 45.0, 29.9],
    'WTG053': [43.6, 45.0, 29.9],
    'WTG054': [43.6, 45.0, 29.9],
    'WTG055': [43.6, 45.0, 29.9],
    'WTG056': [43.6, 45.0, 29.9],
    'WTG057': [43.6, 45.0, 29.9],
    'WTG058': [43.6, 45.0, 29.9],
    'WTG059': [43.6, 45.0, 29.9],
    'WTG060': [43.6, 45.0, 29.9],
    'WTG061': [43.6, 45.0, 29.9],
    'WTG062': [43.6, 45.0, 29.9],
    'WTG063': [43.6, 45.0, 29.9],
    'WTG064': [43.6, 45.0, 29.9],
    'WTG065': [43.6, 45.0, 29.9],
    'WTG066': [43.6, 45.0, 29.9],
    'WTG067': [43.6, 45.0, 29.9],
    'WTG068': [43.6, 45.0, 29.9],
    'WTG069': [43.6, 45.0, 29.9],
    'WTG070': [43.6, 45.0, 29.9],
    'WTG071': [43.6, 45.0, 29.9],
}
